import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckboxHolder from "../CheckboxHolder/CheckboxHolder";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import TitleAndTradingSlider from "../../TitleAndTradingSlider";

function FeeDetails({ hideZeroFee }) {
  const classes = useStyles();

  // const prices = useSelector((state) => state.value.price);
  /*use commented code for main integration*/
  // console.log(prices)

  return (
    <>
      {!hideZeroFee ? (
        <Typography variant="h3" className="mb-3 md:mb-6">
          <strong>0% Fee on</strong>
        </Typography>
      ) : null}
      <div className={`${classes.checkboxes}`}>
        <CheckboxHolder />
      </div>
      {/* <TitleAndTradingSlider></TitleAndTradingSlider> */}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  avgMonthlyTrading: {
    fontWeight: 100,
    flex: 1,
    textAlign: "left",
    marginBottom: "20px",
  },
  checkboxes: {
    marginBottom: "50px",
  },
  oneThousand: {
    textAlign: "center",
    // marginLeft: "55%",
  },
  oneThousandFlex: {
    textAlign: "left",
    flexGrow: "1",
    // marginLeft: "55%",
  },
  oneThousandPlus: {
    // marginLeft: "80%",
  },
}));

export default FeeDetails;
